<div class="container p-3">
    <div class="row">
        <div class="col position-relative">
            <div style="position: absolute; top: 0px; right: 15px;">
                <button class="btn btn-outline-danger" (click)="displayDeleteAccount()" *ngIf="!deleteAccountVisible">
                    <i class="fas fa-trash-alt"></i> Delete
                </button>
                <button class="btn btn-danger" (click)="deleteAccount()" *ngIf="deleteAccountVisible">
                    <i class="fas fa-exclamation-circle"></i> Confirm
                </button>
            </div>
            <ul class="nav nav-tabs mb-3">
                <li class="nav-item"><a class="nav-link" [class.active]="defaultApi == 'v1'" data-bs-toggle="tab" data-bs-target="#user-v1" (click)="defaultApi = 'v1'">v1</a></li>
                <li class="nav-item"><a class="nav-link" [class.active]="defaultApi == 'v2'" data-bs-toggle="tab" data-bs-target="#user-v2" (click)="defaultApi = 'v2'">v2</a></li>
            </ul>
            <div class="tab-content">
                <div id="user-v1" class="tab-pane" [class.active]="defaultApi == 'v1'">
                    <div *ngIf="defaultApi == 'v1'">
                        <user-v1 [accountId]="accountId"></user-v1>
                    </div>
                </div>
                <div id="user-v2" class="tab-pane" [class.active]="defaultApi == 'v2'">
                    <div *ngIf="defaultApi == 'v2'">
                        <user-v2 [accountId]="accountId"></user-v2>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>